<template>
<div class="row">

  <div class="col-12 col-md-4">

    <p class="float-md-left text-center text-left-md mb-0 mt-2">Page {{ pagination.currentPage }} of {{ pagination.totalPages }}</p>

  </div>

  <div class="col-12 col-md-8">
    <span class="float-right">
      <ul class="pagination float-md-right mb-0 d-none d-md-block">

        <li v-if="pagination.currentPage > 1" :class="{ 'active': pagination.currentPage === pagination.firstPage }">
          <a href="#" @click.prevent="paginationClicked(1)">First</a>
        </li>

        <li v-if="pagination.currentPage > 1">
          <a href="#" @click.prevent="paginationClicked(pagination.previousPage)">&nbsp;&lt;</a>
        </li>

        <span v-for="page in pagination.totalPages" :key="page">
          <li v-if="((page < pagination.currentPage + 4) && (page > pagination.currentPage - 4))" :class="{ 'active': pagination.currentPage === page }">
            <a href="#" @click.prevent="paginationClicked(page)">{{ page }}</a>
          </li>
        </span>

        <li v-if="pagination.currentPage < pagination.totalPages">
          <a href="#" @click.prevent="paginationClicked(pagination.nextPage)">&nbsp;&gt;</a>
        </li>

        <li
          v-if="pagination.currentPage !== pagination.totalPages"
          :class="{ 'active': pagination.currentPage === pagination.totalPages }"
        >
          <a href="#" @click.prevent="paginationClicked(pagination.totalPages)">Last</a>
        </li>
      </ul>
    </span>

    <ul class="pagination d-md-none d-block mx-auto text-lg-center mt-3">

      <span class="float-left">

        <li>
          <a href="#" @click.prevent="paginationClicked(pagination.previousPage)"><span :class="[pagination.currentPage > 1 ? 'visible' : 'invisible']">PREV</span></a>
        </li>

      </span>

      <span class="float-right">

        <li>
          <a href="#" @click.prevent="paginationClicked(pagination.nextPage)"><span :class="[pagination.currentPage < pagination.totalPages ? 'visible' : 'invisible']">NEXT</span></a>
        </li>

      </span>

    </ul>

    <ul class="pagination d-md-none d-block mx-auto text-center">

      <span v-for="page in pagination.totalPages" :key="page">
          <li v-if="((page < pagination.currentPage + 4) && (page > pagination.currentPage - 4))" :class="{ 'active': pagination.currentPage === page }">
            <a href="#" @click.prevent="paginationClicked(page)">{{ page }}</a>
          </li>
        </span>

    </ul>

  </div>

</div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  props: {
    stockType: String
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapState(['pagination', 'searchFilters', 'totalNumCars'])
  },
  created () {
  },
  methods: {
    /**
     * For displaying the correct pagination link on hover
     * Display purposes only - no actual functionality
     */
    showPaginationLink (newPage) {
      // if page is 0, mark as undefined to remove from url
      if (newPage === 1) {
        newPage = undefined
      }

      // assign our new page # to searchFilters
      this.searchFilters.page = newPage

      // const queryString = Object.keys(this.searchFilters).map(key => key + '=' + this.searchFilters[key]).join('&')

      var newQuery = []

      Object.keys(this.searchFilters).map(key => {
        if (typeof (this.searchFilters[key]) !== 'undefined') {
          if (this.searchFilters[key].length > 0) {
            if (key === 'page') {
            }
            newQuery.push(key + '=' + this.searchFilters[key])
          }
        }
      })

      newQuery = newQuery.join('&')
      var newUrl = this.$route.path + '?' + newQuery

      return newUrl
    },
    /**
     * This is the actual functionality when pagination links are clicked
     */
    paginationClicked: function (page) {
      // get route name (new or used)
      const name = this.$route.name

      // get new page #
      // let page = Number(el.target.dataset.page)

      // if page is 0, mark as undefined to remove from url
      if (page === 1) {
        page = undefined
      }

      // assign our new page # to searchFilters
      this.searchFilters.page = page

      // push to router
      this.$root.pushToRouter(name, this.searchFilters)

      window.scroll({
        top: 0,
        behavior: 'smooth'
      })
    },
    buildRouterLinkQuery: function (name, page) {
      var returnObject = {}

      if (page === 1) {
        returnObject = { name: name, query: { ...this.searchFilters, page: undefined } }
      } else {
        if ((page < this.pagination.currentPage + 4) && (page > this.pagination.currentPage - 4)) {
          returnObject = { name: name, query: { ...this.searchFilters, page: page } }
        }
      }

      return returnObject
    },
    /**
    * Return previous page
    */
    previousPage: function () {
      var returnObject = {
        name: this.stockType,
        query: { ...this.searchFilters, page: this.pagination.previousPage }
      }
      if (returnObject.query.page === 1) {
        returnObject.query.page = undefined
      }
      return returnObject
    },
    /**
     * Check if paginationSpread is close to currentPage
     */
    isPaginationSpread: function (item) {
      // init settings
      const paginationSpread = 4
      let isWithinSpread = false

      // check if paginationSpread is close to currentPage
      if ((item < this.pagination.currentPage + paginationSpread) && (item > this.pagination.currentPage - paginationSpread)) {
        isWithinSpread = true
      }
      return isWithinSpread
    }
  }
}
</script>

<style scoped>
  .pagination .active {
    text-decoration: none;
    pointer-events: none;
  }
</style>
